/*!

=========================================================
* Argon Dashboard React - v1.2.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

import React, {useState} from 'react';
import { Button, Card, CardBody, CardTitle, Col, Container, Row } from "reactstrap";
import { useAdminUserHeaderInfo } from '../../hooks/useAdminUserHeaderInfo';
import {Group, CloudDownload} from "@material-ui/icons";
import ShowUserExecutionsFilterModal from '../ShowUserExecutionsFilterModal';

const AdminUserScreenHeader: React.FC = () => {
  const { data: headerData, isLoading: headerDataLoading } = useAdminUserHeaderInfo();
  const [inputModalOpen, setInputModalOpen] = useState<boolean>(false);

  const closeTranslationResultModel = () => {
    setInputModalOpen(false);
  }

  const makeModelOpen = () => {
    setInputModalOpen(true)
  }


  return (
    <>
      <div className="header pb-6 pt-5 pt-md-8"
      style={{
        backgroundColor: '#2D315C',
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundImage: "url(/background-header-infinity.jpg)"
      }}>
        <span className="mask bg-gradient-default opacity-8" />
        <Container fluid>
          <div className="header-body">
            {/* Card stats */}
            <Row>
              <Col lg="6" xl="3">
                <Card className="card-stats mb-4 mb-xl-0">
                  <CardBody>
                    <Row>
                      <div className="col">
                        <CardTitle
                          tag="h5"
                          style={{fontSize: "10px"}}
                          className="text-uppercase text-muted mb-0"
                        >
                          Total Users
                        </CardTitle>
                        <span className="h2 font-weight-bold mb-0">
                          {(headerDataLoading || !headerData) ? '...' : headerData.total}
                        </span>
                      </div>
                      <Col className="col-auto">
                        <div className="icon icon-shape bg-danger text-white rounded-circle shadow">
                          <Group/>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
              <Col lg="6" xl="3">
                <Card className="card-stats mb-4 mb-xl-0">
                <CardBody>
                    <Row>
                      <div className="col">
                        <CardTitle
                          tag="h5"
                          style={{fontSize: "10px"}}
                          className="text-uppercase text-muted mb-0"
                        >
                          Execution Report
                        </CardTitle>
                        <span className="font-weight-bold mb-0">
                          <Button href={undefined} onClick={() => makeModelOpen()} 
                          style={{ 
                            padding: '3px 6px',
                            borderRadius: '5px',
                            border: 'none',
                          }}
                          >Download</Button>
                        </span>
                      </div>
                      <Col className="col-auto">
                        <div className="icon icon-shape bg-danger text-white rounded-circle shadow">
                          <CloudDownload/>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
      <ShowUserExecutionsFilterModal open={inputModalOpen} onClose={() => closeTranslationResultModel()} />
    </>
  );
};

export default AdminUserScreenHeader;
